import request from '@/request/biAxios.js'

export function findMzjl(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getMzjzjl',
        method: 'post',
        data
    })
}

export function findZyjl(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getZyjzjl',
        method: 'post',
        data
    })
}

export function findFymxMz(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getMzFymx',
        method: 'post',
        data
    })
}

export function findFymxZy(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getZyFymx',
        method: 'post',
        data
    })
}

export function findJcjl(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getJcjl',
        method: 'post',
        data
    })
}

export function findJyjlMz(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getMzJyjl',
        method: 'post',
        data
    })
}

export function findJyjlZy(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getZyJyjl',
        method: 'post',
        data
    })
}

export function findJyjlMx(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getJyjlmx',
        method: 'post',
        data
    })
}

export function findCf(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getCfzb',
        method: 'post',
        data
    })
}

export function findCfMx(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getCfmxb',
        method: 'post',
        data
    })
}

export function findYpyz(data){
    return request({
        url:'/jkda_api/hzdoc/PatientPortal/getYpyzmx',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/biApi.js